import { render, staticRenderFns } from "./disc-upload.vue?vue&type=template&id=aab43488&scoped=true&"
import script from "./disc-upload.vue?vue&type=script&lang=js&"
export * from "./disc-upload.vue?vue&type=script&lang=js&"
import style0 from "./disc-upload.vue?vue&type=style&index=0&id=aab43488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab43488",
  null
  
)

export default component.exports